import { defineComponent as _defineComponent } from 'vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

interface Props {
  data: {
    items: {
      title: string;
      text: string;
    }[];
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TipsSection',
  props: {
    data: null
  },
  setup(__props: any) {



const breakpoints = useBreakpoints(breakpointsTailwind);
const isDesktop = breakpoints.greater('md');

return { __sfc: true,breakpoints, isDesktop }
}

})